import { render, staticRenderFns } from "./datatable-model.component.vue?vue&type=template&id=d71f0e44"
import script from "./datatable-model.component.vue?vue&type=script&lang=ts"
export * from "./datatable-model.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports